// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__nTJK8","unreadBadge":"styles_unreadBadge__2FnoA","modalContent":"styles_modalContent__3Tg0V","modal":"styles_modal__10EAw"};